/*
 *                        _oo0oo_
 *                       o8888888o
 *                       88" . "88
 *                       (| -_- |)
 *                       0\  =  /0
 *                     ___/`---'\___
 *                   .' \\|     |// '.
 *                  / \\|||  :  |||// \
 *                 / _||||| -:- |||||- \
 *                |   | \\\  - /// |   |
 *                | \_|  ''\---/''  |_/ |
 *                \  .-\__  '-'  ___/-. /
 *              ___'. .'  /--.--\  `. .'___
 *           ."" '<  `.___\_<|>_/___.' >' "".
 *          | | :  `- \`.;`\ _ /`;.`/ - ` : | |
 *          \  \ `_.   \_ __\ /__ _/   .-` /  /
 *      =====`-.____`.___ \_____/___.-`___.-'=====
 *                        `=---='
 *
 *
 *      ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 *
 *            佛祖保佑       永不宕机     永无BUG
 *
 * @Author: 路守恒
 * @LastEditors: 路守恒
 * @Date: 2021-09-02 10:19:30
 * @LastEditTime: 2021-09-24 17:53:56
 * @FilePath: \uniapp-npm\lushh-request\index.js
 * @Description:
 */
import lushhHttp, { http } from './lib/lushh-request.esm.js'

let setConfig = (config) => {
  try {
    http.defaults.baseURL = config.baseURL
  } catch (error) {}
  try {
    http.config.baseURL = config.baseURL
  } catch (error) {}
}
export { lushhHttp, setConfig }

const install = (Vue) => {
  Vue.prototype.$lushhHttp = lushhHttp
}
export default { install }
